module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"infos":"Informações","orders":"Pedidos","subscriptions":"Assinaturas"},"en-US":{"infos":"Informations","orders":"Orders","subscriptions":"Subscriptions"}}')
  delete Component.options._Ctor
}
